import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiRequest } from "../api";
import { ui, uiHandlers } from "../uiStyles";

export default function ClientNew() {
  const navigate = useNavigate();
  const [err, setErr] = useState("");
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    company_name: "",
    contact_name: "",
    email: "",
    phone: "",
    address: "",
    notes: "",
  });

  function update(field, value) {
    setForm((prev) => ({ ...prev, [field]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setErr("");
    setSaving(true);

    try {
      await apiRequest("/clients", { method: "POST", body: form });
      navigate("/clients/management");
    } catch (e) {
      setErr(e?.message || "Could not create client.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={{ ...ui.page, maxWidth: 760 }}>
      <div style={{ marginBottom: 18 }}>
        <Link to="/clients/management" style={ui.link}>
          ← Back to Client Management
        </Link>

        <h2 style={{ color: "#ffffff", marginBottom: 6 }}>Create New Client</h2>
        <p style={{ color: "#9fb0c3", marginTop: 0 }}>
          Add the client first. Jobs, estimates, and invoices should be created from the job workflow.
        </p>
      </div>

      {err && (
        <div
          style={{
            ...ui.card,
            marginBottom: 16,
            background: "rgba(127, 29, 29, 0.28)",
            border: "1px solid rgba(239, 68, 68, 0.35)",
            color: "#fecaca",
          }}
        >
          {err}
        </div>
      )}

      <form onSubmit={handleSubmit} style={ui.card}>
        <div style={{ display: "grid", gap: 14 }}>
          <label>
            <div style={label}>Company Name</div>
            <input
              value={form.company_name}
              onChange={(e) => update("company_name", e.target.value)}
              style={ui.input}
              {...uiHandlers.focus}
            />
          </label>

          <label>
            <div style={label}>Contact Name</div>
            <input
              value={form.contact_name}
              onChange={(e) => update("contact_name", e.target.value)}
              style={ui.input}
              {...uiHandlers.focus}
            />
          </label>

          <label>
            <div style={label}>Email</div>
            <input
              type="email"
              value={form.email}
              onChange={(e) => update("email", e.target.value)}
              style={ui.input}
              {...uiHandlers.focus}
            />
          </label>

          <label>
            <div style={label}>Phone</div>
            <input
              value={form.phone}
              onChange={(e) => update("phone", e.target.value)}
              style={ui.input}
              {...uiHandlers.focus}
            />
          </label>

          <label>
            <div style={label}>Address</div>
            <input
              value={form.address}
              onChange={(e) => update("address", e.target.value)}
              style={ui.input}
              {...uiHandlers.focus}
            />
          </label>

          <label>
            <div style={label}>Notes</div>
            <textarea
              value={form.notes}
              onChange={(e) => update("notes", e.target.value)}
              style={{ ...ui.input, minHeight: 120 }}
              {...uiHandlers.focus}
            />
          </label>

          <button
            type="submit"
            disabled={saving}
            style={{
              ...ui.btnPrimary,
              opacity: saving ? 0.7 : 1,
              cursor: saving ? "not-allowed" : "pointer",
            }}
            {...(!saving ? uiHandlers.primaryHover : {})}
          >
            {saving ? "Saving..." : "Create Client"}
          </button>
        </div>
      </form>
    </div>
  );
}

const label = {
  color: "#dbe7f3",
  fontSize: 13,
  fontWeight: 700,
  marginBottom: 6,
};
